import React, { ReactNode } from "react";
import { Modal as AntModal, ModalProps as AntModalProps } from "antd";
import classNames from "classnames";
import Button from "@Components/Button";
import "./Modal.scss";
import { MODAL_SIZE } from "@Configs/enum";
import { Close, ArrowLeft } from "assets/icons";

export interface ModalCustomProps extends AntModalProps {
  children?: ReactNode;
  /**Is the modal footer (cancel, apply, apply next button) visible or not*/
  visibleFooter?: boolean;
  /**Change the size of modal*/
  size?: MODAL_SIZE;
  /**Name of apply button*/
  titleButtonApply?: string;
  /**Name of apply next button*/
  /**Name of cancel button*/
  titleButtonCancel?: string;
  /**Cancel the form (Button type secondary)*/
  handleCancel?: (event: any) => void;
  /**Function pass when you need to handle a different feature*/
  handleClickIcon?: (event: any) => void;
  /**Save the form (Button type primary)*/
  handleSave?: (event: any) => void;
  /**Apply and process to next form*/
  /**Pass disable for button cancel */
  disableButtonCancel?: boolean;
  /**Pass disable for button apply */
  disableButtonApply?: boolean;

  isShowButtonCancel?: boolean;

  isShowButtonApply?: boolean;

  isShowIconBack?: boolean;
}

function Modal(props: ModalCustomProps) {
  const {
    open,
    visibleFooter = true,
    size = MODAL_SIZE.SIZE_1000,
    titleButtonApply,
    titleButtonCancel,
    handleCancel,
    handleSave,
    isShowButtonCancel = true,
    isShowButtonApply = true,
    isShowIconBack = true,
    disableButtonCancel = false,
    disableButtonApply = false,
    handleClickIcon,
  } = props;

  const renderModalFooter = React.useMemo(
    () => (
      <div className={classNames("footer-modal")}>
        <div
          className={classNames("button-bleed-footer", {
            center: size === MODAL_SIZE.SIZE_400,
          })}
        >
          {isShowButtonCancel && (
            <Button
              type="secondary"
              onClick={handleCancel}
              disabled={disableButtonCancel}
            >
              <span>{titleButtonCancel ? titleButtonCancel : "Cancel"}</span>
            </Button>
          )}
          {isShowButtonApply && (
            <Button
              type="primary"
              disabled={disableButtonApply}
              onClick={handleSave}
            >
              <span>{titleButtonApply ? titleButtonApply : "Apply"}</span>
            </Button>
          )}
        </div>
      </div>
    ),
    [
      size,
      handleCancel,
      disableButtonCancel,
      titleButtonCancel,
      handleSave,
      disableButtonApply,
      titleButtonApply,
    ]
  );

  React.useEffect(() => {
    if (open) {
      const handleEscKey = (event: KeyboardEvent) => {
        if (event.key === "Escape") {
          handleCancel(null);
        }
      };
      document.addEventListener("keydown", handleEscKey);
      return () => {
        document.removeEventListener("keydown", handleEscKey);
      };
    }
  }, [open, handleCancel]);

  const getShowFooter = () => {
    if ((!isShowButtonApply && !isShowButtonCancel) || !visibleFooter) {
      return null;
    }
    return renderModalFooter;
  };

  return (
    <>
      <AntModal
        {...props}
        centered
        className={classNames("modal__container__normal", props?.className)}
        closeIcon={null}
        title=""
        footer={getShowFooter()}
        onCancel={
          typeof handleClickIcon === "function" ? handleClickIcon : handleCancel
        }
        width={size}
        keyboard={false}
      >
        <div className="modal_content">
          <div className="header-modal">
            <div className="header-left">
              {isShowIconBack && (
                <div
                  onClick={
                    typeof handleClickIcon === "function"
                      ? handleClickIcon
                      : handleCancel
                  }
                  className="center-icon"
                >
                  <ArrowLeft />
                </div>
              )}
              <div className="title">{props.title}</div>
            </div>
            <div
              onClick={
                typeof handleClickIcon === "function"
                  ? handleClickIcon
                  : handleCancel
              }
              className="center-icon"
            >
              <Close />
            </div>
          </div>
          <div className="body-modal">{props.children}</div>
        </div>
      </AntModal>
    </>
  );
}

export default Modal;
